module.exports = __webpack_public_path__ + "img/9891667196348_.pic3@2x.ed58666b.png";